<ng-container *ngIf="showHyperlink; else showNormal">
  <a [href]="'https://' + value" target="_blank">{{ value || 'N/A' }}</a>
</ng-container>
<ng-template #showNormal>
  <p style="overflow-wrap: anywhere">{{ value || 'N/A' }}</p>
</ng-template>
